import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Download, AlertTriangle } from "lucide-react";

export default function BackupSettings() {
  const [loading, setLoading] = useState(false);

  const download = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/backup/export");
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `redaktionssystem-backup-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Backup heruntergeladen");
    } catch (e) { toast.error("Backup fehlgeschlagen"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl">
      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Datenbank-Backup &amp; Wiederherstellung</h2>
        <p className="text-sm text-slate-500">Sichere deine Daten regelmäßig – besonders vor größeren Änderungen.</p>
        <div className="flex items-start gap-2 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">
          <AlertTriangle size={16} className="mt-0.5 shrink-0" />
          Erstelle regelmäßig Backups, besonders vor Updates oder größeren Änderungen.
        </div>
        <Button onClick={download} disabled={loading} className="bg-[#0B132B] hover:bg-[#1C2541]" data-testid="backup-download">
          <Download size={16} className="mr-1.5" /> {loading ? "Erstelle Backup…" : "Backup herunterladen (JSON)"}
        </Button>
        <div className="text-sm text-slate-500">
          <div className="font-medium text-slate-700 mb-1">Im Backup enthalten:</div>
          Benutzer, Ausgaben, Kategorien, Artikel, Anzeigenkunden, Mailvorlagen, Status-Labels, Einstellungen, Versand-Protokoll.
          <div className="text-xs text-slate-400 mt-1">Nicht enthalten: Passwörter (Hashes werden aus Sicherheitsgründen entfernt).</div>
        </div>
        <div className="border-t border-slate-100 pt-3 text-xs text-slate-400">
          Wiederherstellung aus einer Backup-Datei wird im nächsten Schritt ergänzt.
        </div>
      </div>
    </div>
  );
}
